import { useRef } from 'react'
import { useRequest } from 'ahooks'

import { Table } from '@sar/component'
import { UploadImage, UploadFile } from 'components'

import { Spin } from 'antd'
import { ProForm, ProFormText, ProFormSelect, ProFormDigit, ProFormDependency, ProFormTextArea } from '@ant-design/pro-components'

export default function ({ store, params, navigator, location }) {
  const [ form ] = ProForm.useForm()
  const [ fileType ] = React.useMemo(() => [ store.config.getConstantPairs('FileType') ], [])

  const res = useRequest<any, any>(() => store.externals.api.get(`/paymentRecords/flow/detail/${params.id}`), {
    refreshDeps: [
      params.id,
    ]
  })

  const handleSubmit = useRequest<any, any>(data => store.externals.api.post(`/paymentRecords/flow/${params.id}`, Object.assign(data, {
    payStatus: data.payStatus.join(','),
    fileManageList: data.fileManageList.map(file => ({ ...file, fileName: file.filename }))
  })), {
    manual: true,
  })

  React.useEffect(() => {
    if (res.data) {
      form.setFieldsValue({
        receipt: res.data.fileManageList.filter(file => file.type == fileType.receiptVoucher).map(file => ({ ...file, filename: file.fileName })),
        excel: res.data.fileManageList.filter(file => file.type == fileType.quotationFile).map(file => ({ ...file, filename: file.fileName })),
        noDepositReason: res.data.orders.noDepositReason,
        isDeposit: res.data.orders.isDeposit,
      })
    }
  }, [
    res.data
  ])

  return <div className='p-4 m-4 bg-white'>
    <table className='w-full border-collapse border border-slate-300 mb-8'>
      <thead>
        <tr>
          <th colSpan={4} className='border border-slate-300 text-left p-3 bg-gray-200 text-gray-600 font-bold'>订单信息</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>订单编号</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-white'>{res.data?.orders?.number}</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>客户姓名</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'>{res.data?.orders?.customerName}</td>
        </tr>

        <tr>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>联系电话</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'>{res.data?.orders?.customerPhone}</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>下单时间</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'>{res.data?.orders?.createTime}</td>
        </tr>

        <tr>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>尾款金额</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'>{res.data?.orders?.totalAmount - res.data?.orders?.paidAmount}</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>已收金额</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'>{res.data?.orders?.paidAmount}</td>
        </tr>

        <tr>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'>总金额</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'>{res.data?.orders?.totalAmount}</td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100 text-gray-500 font-bold'></td>
          <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-white'></td>
        </tr>
      </tbody>
    </table>

    <ProForm
      form={form}
      loading={res.loading}
      rowProps={{ gutter: 24 }}
      layout='vertical'
      onFinish={data => handleSubmit.runAsync(data).then(() => store.history.del(location.pathname)).then(() => navigator.back())}
      submitter={{
        searchConfig: {
          submitText: '提交',
        },
        resetButtonProps: {
          style: {
            display: 'none',
          },
        },
      }}
    >
      <ProFormDependency name={[ 'isDeposit' ]}>
        {({ isDeposit }) => {
          if (isDeposit == 'no') {
            return null
          }

          return <UploadImage
            readonly
            max={10000}
            name='receipt'
            label='报价时收款凭证'
            help='建议尺寸800*800px'
          />
        }}
      </ProFormDependency>

      <UploadFile
        readonly
        max={10}
        name='excel'
        label='报价xls文件存档'
      />

      <ProFormDependency name={[ 'isDeposit' ]}>
        {({ isDeposit }) => {
          if (isDeposit == 'yes') {
            return null
          }

          return <ProFormTextArea
            readonly
            name='noDepositReason'
            label='报价时没有收款下单原因'
            fieldProps={{ rows: 6 }}
          />
        }}
      </ProFormDependency>

      <ProFormSelect
        name='item'
        label='货款类型'
        width='xl'
        valueEnum={{
          '订金': '订金',
          '尾款': '尾款',
          '预付款': '预付款',
        }}
        rules={[ { required: true, message: '请填写货款类型' } ]}
      />

      <ProFormSelect
        name='payStatus'
        label='收款方式（如预设不符合可自填）'
        width='xl'
        rules={[ { required: true, message: '请填写收款方式' } ]}
        fieldProps={{ mode: 'tags' }}
        valueEnum={store.config.getConstantEnums(`PaymentType`)}
      />

      <ProFormDigit
        name='amount'
        label='收款金额'
        width='xl'
        min={0}
        fieldProps={{ precision: 2 }}
        rules={[ { required: true, message: '请填写收款金额' } ]}
      />

      <UploadImage
        max={10000}
        name='fileManageList'
        label='上传收款凭证'
        help='建议尺寸800*800px'
        rules={[ { required: true, message: '请上传收款凭证' } ]}
        fieldProps={{ upload: file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(res => `//${store.oss.endpoint}/${res.name}`) }}
      />
    </ProForm>
  </div>
}
